import { types } from '../types'

const initialState = {
    waiting: false,
    success: false,
    error: '',

}

const settingReducer = (state = initialState, { type, action, error }) => {
    switch (type) {


        case types.GET_DEPARTMENTS_REQUEST: {

            return {
                ...state,
                getDepartmentPending: true,
                departments: null
            }
        }

        case types.GET_DEPARTMENTS_SUCCESS: {

            return {
                ...state,
                getDepartmentPending: false,
                /// should be change after implementation of API
                departments: JSON.parse(action.data).departments.department
            }
        }

        case types.GET_DEPARTMENTS_ERROR: {

            return {
                ...state,
                getDepartmentPending: false,
                getDepartmentError: error
            }
        }


        ///--- create ticket

        case types.CREATE_TICKET_REQUEST: {

            return {
                ...state,
                createTicketPending: true,
                createTicketSuccess: false,
                createTicketError: ''

            }
        }

        case types.CREATE_TICKET_SUCCESS: {
            return {
                ...state,
                createTicketPending: false,
                createTicketSuccess: true,

            }
        }

        case types.CREATE_TICKET_ERROR: {

            return {
                ...state,
                createTicketPending: false,
                createTicketError: error
            }
        }

        case types.GET_TICKETS_REQUEST: {

            return {
                ...state,
                getTicketsPending: true,
                getTicketsSuccess: false,
                getTicketsError: '',
                userTickets: null

            }
        }

        case types.GET_TICKETS_SUCCESS: {

            return {
                ...state,
                getTicketsPending: false,
                getTicketsSuccess: true,
                userTickets: JSON.parse(action.data).tickets.ticket


            }
        }

        case types.GET_TICKETS_ERROR: {

            return {
                ...state,
                getTicketsPending: false,
                getTicketsError: error
            }
        }


        case types.GET_TICKET_REQUEST: {

            return {
                ...state,
                getTicketPending: true,
                getTicketSuccess: false,
                getTicketError: '',
                // selectedTicket: null

            }
        }

        case types.GET_TICKET_SUCCESS: {

            return {
                ...state,
                getTicketPending: false,
                getTicketSuccess: true,
                selectedTicket: JSON.parse(action.data)


            }
        }

        case types.GET_TICKET_ERROR: {

            return {
                ...state,
                getTicketPending: false,
                getTicketError: error
            }
        }


        case types.REPLAY_TICKET_REQUEST: {

            return {
                ...state,
                replayTicketPending: true,
                replayTicketSuccess: false,
                replayTicketError: ''

            }
        }

        case types.REPLAY_TICKET_SUCCESS: {

            return {
                ...state,
                replayTicketPending: false,
                replayTicketSuccess: true,


            }
        }

        case types.REPLAY_TICKET_ERROR: {

            return {
                ...state,
                replayTicketPending: false,
                replayTicketError: error
            }
        }

        case types.GET_TICKET_ATTACHMENT_REQUEST: {

            return {
                ...state,
                getTicketAttachmentPending: true,
                getTicketAttachmentSuccess: false,
                getTicketAttachmentError: '',
                attachmentFile: null

            }
        }

        case types.GET_TICKET_ATTACHMENT_SUCCESS: {

            return {
                ...state,
                getTicketAttachmentPending: false,
                getTicketAttachmentSuccess: true,
                attachmentFile: JSON.parse(action.data)


            }
        }

        case types.GET_TICKET_ATTACHMENT_ERROR: {

            return {
                ...state,
                getTicketAttachmentPending: false,
                getTicketAttachmentError: error
            }
        }


        case types.POST_TICKET_API_RUNNER_REQUEST: {

            return {
                ...state,
                getTicketAPIRunnerPending: true,
                getTicketAPIRunnerSuccess: false,
                getTicketAPIRunnerError: null,
                apiRunnerResult: null
            }
        }

        case types.POST_TICKET_API_RUNNER_SUCCESS: {

            return {
                ...state,
                getTicketAPIRunnerPending: false,
                getTicketAPIRunnerSuccess: true,
                apiRunnerResult: JSON.parse(action.data)

            }
        }

        case types.POST_TICKET_API_RUNNER_ERROR: {

            return {
                ...state,
                getTicketAPIRunnerPending: false,
                getTicketAPIRunnerError: error
            }
        }



        case types.SUPPORT_RESET_PROPS: {
            return {
                ...state,
                getDepartmentPending: false,
                getDepartmentError: false,
                createTicketPending: false,
                createTicketSuccess: false,
                createTicketError: '',
                getTicketsPending: false,
                getTicketsSuccess: false,
                getTicketsError: '',
                replayTicketPending: false,
                replayTicketSuccess: false,
                replayTicketError: '',
                getTicketAttachmentPending: false,
                getTicketAttachmentSuccess: false,
                getTicketAttachmentError: '',
                getTicketAPIRunnerPending: false,
                getTicketAPIRunnerSuccess: false,
                getTicketAPIRunnerError: null,
                apiRunnerResult: null


            }
        }
        default:
            return state
    }
}

export default settingReducer;